export function readViewport() {
  const vv = window.visualViewport || null;
  return {
    w: Math.round(window.innerWidth || 0),
    h: Math.round(window.innerHeight || 0),
    ow: Math.round(window.outerWidth || 0),
    oh: Math.round(window.outerHeight || 0),
    dpr: Number(window.devicePixelRatio || 1),
    vvw: vv ? Math.round(vv.width) : null,
    vvh: vv ? Math.round(vv.height) : null,
    vvs: vv ? Number(vv.scale || 1) : null,
    orient:
      (window.innerWidth || 0) >= (window.innerHeight || 0)
        ? 'landscape'
        : 'portrait',
  };
}
